import FJActionConstant from '../constant/FJActionConstant';

let initData = {
    show: false,
    method: 'single',
    page: '',
    email: '',
    registerCode: '', // 注册时使用的验证码
    confirmEmail: '',
    step: 'default',
    countryCode: null,

    passwordSeeLogin: false, // 登录面板

    registerPassword: '', // 注册面板密码

    time: null, // 全局定时器剩余时间,现用于保存新用户不更改邮箱情况下获取验证码频率
    verificationTimeShow: false,

    forgetPasswordTime: null, // 忘记密码剩余时间
    forgetPasswordTimeShow: false,
};
const mainStore = (state = initData, action) => {
    switch (action.type) {
        case FJActionConstant.SHOW_LOGIN_VIEW:
            return {
                ...state,
                show: true,
                method: action.method,
                page: action.page,
                email: action.email,
            };
        case FJActionConstant.CLOSE_LOGIN_VIEW:
            return {
                ...state,
                show: false,
            };
        case FJActionConstant.CHANGE_STEP:
            return {
                ...state,
                step: action.step,
            };
        case FJActionConstant.CHANGE_REGISTER_PASSWORD:
            return {
                ...state,
                registerPassword: action.password,
            };
        case FJActionConstant.CHANGE_EMAIL:
            return {
                ...state,
                email: action.email,
            };

        case FJActionConstant.CHANGE_CONFIRM_EMAIL:
            return {
                ...state,
                confirmEmail: action.confirmEmail,
            };
        case FJActionConstant.CHANGE_COUNTRY_CODE:
            return {
                ...state,
                countryCode: action.countryCode,
            };
        case FJActionConstant.CHANGE_LOGIN_PASSWORD_STATUS:
            return {
                ...state,
                passwordSeeLogin: action.status,
            };
        case FJActionConstant.SET_INTERVAL_TIME:
            return {
                ...state,
                time: action.value,
            };
        case FJActionConstant.VERIFICATION_TIME_SHOW:
            return {
                ...state,
                verificationTimeShow: action.value,
            };
        case FJActionConstant.SET_FORGET_PASSWORD_INTERVAL_TIME:
            return {
                ...state,
                forgetPasswordTime: action.value,
            };
        case FJActionConstant.FORGET_PASSWORD_TIME_SHOW:
            return {
                ...state,
                forgetPasswordTimeShow: action.value,
            };
        case FJActionConstant.CHANGE_REGISTER_CODE:
            return {
                ...state,
                registerCode: action.registerCode,
            };
        default:
            return state;
    }
};
export default mainStore;
